var productSlider = jq('.product-slider');
if (productSlider.length) {
    productSlider.slick({
      infinite: true,
      dots: false,
      variableWidth: false,
      arrows: true,
      prevArrow: '<div class="prev prev-arrow"><span class="glyphicon glyphicon-menu-left"></span></div>',
      nextArrow: '<div class="next next-arrow"><span class="glyphicon glyphicon-menu-right"></span></div>',
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            variableWidth: false,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
            slidesToScroll: 1
          }
        }
      ]
    });    
}
jq(document).ready(function(){
    // Home hero: size the cycle-slideshow container to the ACTIVE slide's
    // height (per-slide natural height) instead of cycle2's built-in modes
    // ("container" clips taller slides; "calc" leaves whitespace under
    // shorter slides). Handles first paint, every slide change, and
    // viewport resizes.
    (function () {
        var $shows = jq('.home-hero').closest('.cycle-slideshow');
        if (!$shows.length) return;

        function syncHeight($show, $slide) {
            if (!$slide || !$slide.length) return;
            $show.css('height', $slide.outerHeight() + 'px');
        }

        // On mobile the blurb strip sits in-flow under the headline/CTA, so
        // CSS `top: 50%` on the chevrons lands on the seam. Pin them to the
        // midpoint of the copy block instead. Desktop keeps the CSS 50%.
        function syncArrows($show, $slide) {
            var $arrows = $show.children('.controls.next, .controls.prev');
            if (!$arrows.length) return;
            if (!window.matchMedia('(max-width: 767px)').matches) {
                $arrows.css('top', '');
                return;
            }
            if (!$slide || !$slide.length) return;
            var $copy = $slide.find('.vertical-align').first();
            var copyHeight = $copy.outerHeight();
            if (!$copy.length || !copyHeight) return;
            var top = ($copy.offset().top - $show.offset().top) + (copyHeight / 2);
            $arrows.css('top', Math.round(top) + 'px');
        }

        function syncShow($show, $slide) {
            syncHeight($show, $slide);
            syncArrows($show, $slide);
        }

        function activeSlide($show) {
            var $active = $show.find('> .cycle-slide-active').first();
            if (!$active.length) {
                $active = $show.find('> .slide.active').first();
            }
            if (!$active.length) {
                $active = $show.find('> .slide').first();
            }
            return $active;
        }

        $shows.each(function () {
            var $show = jq(this);
            $show.on('cycle-initialized cycle-after', function (e, opts) {
                syncShow($show, activeSlide($show));
            });
            $show.on('cycle-before', function (e, opts, currSlide, nextSlide) {
                syncShow($show, jq(nextSlide));
            });
            // First paint in case cycle already initialized before this handler bound.
            syncShow($show, activeSlide($show));
        });

        var resizeTimer;
        jq(window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                $shows.each(function () {
                    var $show = jq(this);
                    syncShow($show, activeSlide($show));
                });
            }, 100);
        });
    })();

    // WAVE Error fixes
    jq('.bootstrap-select .dropdown-menu li').each(function(){
        jq(this).attr('role', 'menuitem');
    });
    if (jq('.page-type-elastic-search').length) {
        setTimeout(function() {
            jq('#react-select-2-input').attr('aria-label', 'search');
            jq('#react-select-3-input').attr('aria-label', 'search');
            jq('#search-container').append('<label class="sr-only" id="downshift-0-label">Search</label>');
            jq('.button.sui-search-box__submit').append('<span class="sr-only">Submit</span>');
        }, 1500);
    }
    
    if (jq("#search-container")) {
        setTimeout(function() {
            jq("button.sui-search-box__submit").attr('aria-label', 'Search');
            jq('input.css-gj7qu5-dummyInput').each(function(index){
              if(index === 0) {
                jq(this).attr('aria-label', 'Sort by');
              } else if(index === 1) {
                jq(this).attr('aria-label', 'Show per page');
              } else {
                jq(this).attr('aria-label', 'Filter');
              }
            });
            jq("input.sui-search-box__text-input").attr('aria-label', 'Search box');
            jq("input.sui-search-box__text-input").removeAttr('aria-labelledby');
            jq(".sui-layout-header__inner form").removeAttr('aria-labelledby');
        }, 1000);
    }
    // End WAVE Error fixes
    // Show the submit button when javascript is enabled
    // Ticket: https://equisolve.freshdesk.com/a/tickets/510176
    jq('#contact-form--captcha .form-submit--hidden').removeClass('form-submit--hidden');
});
// Enable the submit button on the Contact Form after the recaptcha box is checked.
// Ticket: https://equisolve.freshdesk.com/a/tickets/510176
function recaptchaCallback() {
    jq('#contact-form--captcha .submit--btn').attr('disabled', false);
};